import { useAccordionItem } from "@website/ui-old/accordion/accordion.hook";
import styles from "@website/ui-old/accordion/accordion.module.scss";
import { AccordionPropertiesType } from "@website/ui-old/accordion/accordion.types";
import { Button } from "@website/ui-old/button";
import { deepCompare } from "@website/utils/deep-compare";
import { FC, memo } from "react";

const Accordion: FC<AccordionPropertiesType> = (properties) => {
  const {
    buttonText,
    buttonProperties,
    detailsProperties,
    summeryProperties,
    expanded
  } = useAccordionItem(properties);
  const {
    content,
    disabled,
    title,
    subtitle,
    variant = "outline",
    scroll,
    StartIcon,
    noOverflowHidden
  } = properties;

  return (
    <details
      {...detailsProperties}
      className={`${styles["details"]} ${styles[variant]} ${
        disabled ? styles["disabled"] : ""
      }`}
    >
      <summary {...summeryProperties} className={styles["summary"]}>
        <h3 className={styles["title"]}>
          {StartIcon ? <div className={styles["icon"]}>{StartIcon}</div> : null}
          {title}
        </h3>
        {subtitle ? (
          <span className={styles["subtitle"]}>{subtitle}</span>
        ) : null}
        <Button className={styles["button"]} {...buttonProperties}>
          {buttonText}
        </Button>
      </summary>
      <div
        className={`${styles["content-wrapper"]} ${
          expanded ? "" : styles["collapsed"]
        } ${noOverflowHidden ? styles["no-overflow"] : ""}`}
      >
        <div className={`${styles["content"]} ${scroll ? styles[scroll] : ""}`}>
          {content}
        </div>
      </div>
    </details>
  );
};

const AccordionMemoized = memo(Accordion, deepCompare);
/**
 * @deprecated please use @website/ui instead
 */
export { AccordionMemoized /**
 * @deprecated please use @website/ui instead
 */ as Accordion };
